// extracted by mini-css-extract-plugin
export default {"button":"TrashCanButton_button__XDMt7"};